<template>
  <div class="container-box">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">租赁方案详情</template>
        <div class="splitline"></div>
      </QS-h3-title>
      <QS-h4-title title="方案信息" />
      <div>
        <column-box-expand
          :list="baseCloumn"
          :source="baseSource"
          :separator="columnSeparator"
        />
      </div>
      <QS-h4-title title="租赁规则" />
      <div class="orderConfig">
        <column-box-expand
          :list="configColumn"
          :source="configSource"
          :separator="columnSeparator"
        />
      </div>
      <QS-h4-title title="司机权益" />
      <div class="orderConfig">
        <column-box-expand
          :list="driverBenefitColumn"
          :source="driverBenefitSource"
          :separator="columnSeparator"
        />
      </div>

      <QS-h4-title title="履约规则" />
      <div class="orderConfig">
        <column-box-expand
          :list="fulfillmentColumn"
          :source="fulfillmentSource"
          :separator="columnSeparator"
        />
      </div>

      <other-collection-items-detail
        v-if="
          configSource.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI
        "
        :dataList="receiveData"
      />

      <template slot="bottomAction">
        <el-button
          v-if="
            state === 0 && this.judgePermission('for_rent_config_ren_plan_edit')
          "
          @click="goEditPage"
          type="primary"
          size="small"
          >编辑</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import { getLeaseSchemeDetail } from '@/api/domain/leaseScheme'
import { PAY_MODE_TEXT } from '@/config/rentConfig'
import {
  PAY_PLANT_TYPE,
  payModeList,
  payPlanTypeList,
  PLANT_AMOUNT_TYPE,
  RENT_AMOUNT_TYPE,
} from '@/components/DriverCooperationRules/DriverSettlementConfig/config.js'
import { getSettlementAmountFormula } from '@/components/DriverCooperationRules/DriverSettlementConfig/utils.js'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import SelectOption from '@/store/dict/selectOptionDict'
import { TEMPLATE_STATE_MAP } from '@/store/dict/templateDict'
import { mapGetters } from 'vuex'
import OtherCollectionItemsDetail from '../components/otherCollectionItemsDetailNew'
import { DRIVING_LICENSE_OPTIONS } from '../const.js'
import { getEnum } from '@/api/global'

export default {
  name: 'LeaseSchemeDetail',
  data() {
    return {
      // 阶梯方案数据
      piecewiseConfigList: [],
      id: '',
      state: '',
      carAgeOptions: [],
      baseSource: {
        id: '',
        name: '',
        stateName: '',
        gmtCreate: '',
        modelName: '',
        introduction: '',
        explanation: '',
        cityNames: '',
        brandSeriesName: '',
        carAge: '',
        hasDrivingLicense: '',
      },
      baseCloumn: [
        { name: '方案ID', key: 'id' },
        { name: '方案状态', key: 'stateName' },
        { name: '创建时间', key: 'gmtCreate' },
        { name: '方案名称', key: 'name' },
        { name: '城市', key: 'cityNames' },
        { name: '品牌车系', key: 'brandSeriesName' },
        { name: '车型', key: 'modelName' },
        { name: '车龄', key: 'carAge' },
        { name: '是否有车证', key: 'hasDrivingLicense' },
      ],
      configColumn: [
        {
          name: '租赁类型',
          key: 'rentCategoryName',
        },
        {
          name: '租期',
          key: 'rentPeriodName',
        },
        {
          name: '收款方式',
          key: 'payModeName',
        },
        {
          name: '结算周期',
          key: 'payMode',
          driverCooperationMode: true,
        },
        {
          name: '租金金额',
          key: 'driverRentAmount',
          driverCooperationMode: true,
        },
        {
          name: '结算模式',
          key: 'payPlanType',
          driverCooperationMode: true,
        },
        {
          name: '结算金额',
          key: 'settlementAmount',
          driverCooperationMode: true,
          tableList: [],
        },
        {
          name: '结算金额',
          key: 'planAmount',
          driverCooperationMode: true,
        },
      ],
      configSource: {
        rentCalculationRules: '自定义',
        payFormName: '分期支付',
        payTypeName: '按月预付',
        billDayName: '31号（按自然月为计租周期）',
        rentPeriodName: '',
        rentAmount: '',
        deposit: '',
        rentCategory: '',
        payModeName: '',
        payMode: '',
        payDay: '--',
        payPlanType: '',
        settlementAmount: '',
        planAmount: '--',
        driverRentAmount: '--',
      },
      fulfillmentColumn: [
        { name: '签约主体', key: 'entityName' },
        { name: '可发车门店', key: 'storeNames' },
        { name: '合同模板', key: 'templateName' },
      ],
      fulfillmentSource: {
        entityName: '',
        storeNames: '',
        templateName: '',
      },
      driverBenefitColumn: [{ name: '租期赠送', key: 'presentDays' }],
      driverBenefitSource: {
        presentDays: '',
      },
      CATEGORY_CODE_MAP,
      receiveData: [],
    }
  },
  components: {
    OtherCollectionItemsDetail,
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    ...mapGetters(['cityCodeMap']),
  },
  mounted() {
    this.id = this.$route.query.id
    if (!this.id) {
      this.$message.error('缺少ID参数')
      return false
    } else {
      this.fetchCarAgeOptions()
      this.getDetail()
    }
  },
  methods: {
    // 获取详情
    getDetail() {
      getLeaseSchemeDetail({
        id: this.id,
      }).then(({ code, data }) => {
        if (code === 1) {
          this.state = data.state
          this.setData(data)
        }
      })
    },
    // 设置值
    async setData(data) {
      const res = await this.$store.dispatch('getPaymentMethods', {
        type: 'rentCategory',
      })
      const rentCategoryList = res.data
      this.baseSource.id = this.id
      this.baseSource.stateName = !this.validateIsEmptyValue(data.state)
        ? SelectOption.leasingSchemeState[String(data.state)]
        : ''
      this.baseSource.gmtCreate = data.gmtCreate
      this.baseSource.name = data.name
      this.baseSource.modelName = data.modelName
      if (data.templateState === TEMPLATE_STATE_MAP.JIN_YONG) {
        this.fulfillmentSource.templateName = `${data.templateName}(禁用)`
      } else {
        this.fulfillmentSource.templateName = data.templateName
      }
      this.baseSource.introduction = data.introduction
      this.baseSource.explanation = data.explanation
      this.baseSource.cityNames = data?.cityNames?.toString() || '--'
      this.baseSource.brandSeriesName =
        [data?.brandName, data?.seriesName].filter(Boolean).join('/') || '--'
      this.baseSource.carAge =
        this.carAgeOptions.find((item) => item.code === data.age)?.name || '--'
      this.baseSource.hasDrivingLicense =
        DRIVING_LICENSE_OPTIONS.find((item) => item.value === data.carCert)
          ?.label || '--'
      this.fulfillmentSource.storeNames =
        data?.storeList?.map((s) => s.storeName).join('、') || '--'
      this.fulfillmentSource.entityName = data?.entityInfo?.entityName || '--'
      // 租赁类别
      this.configSource.rentCategoryName =
        this.formatEnumeration(rentCategoryList)[data.rentCategory]
      this.configSource.rentCategory = data.rentCategory

      // 非司机合作模式过滤司机合作模式字段
      if (data.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        this.configColumn = this.configColumn.filter(
          (item) => !item.driverCooperationMode,
        )
      }

      const isValid = !this.validateIsEmptyValue(data.rentPeriod)
      if (data.rentPeriodType === 1) {
        this.configSource.rentPeriodName = isValid ? `${data.rentPeriod}天` : ''
      } else if (data.rentPeriodType === 3) {
        this.configSource.rentPeriodName = isValid
          ? `${data.rentPeriod}个月`
          : ''
      }
      this.configSource.rentAmount =
        data.rentAmount || data.rentAmount === 0 ? data.rentAmount : ''
      this.configSource.deposit =
        data.deposit || data.deposit === 0 ? data.deposit : ''
      this.configSource.payModeName = PAY_MODE_TEXT[data.payMode] || '--'
      this.driverBenefitSource.presentDays = data?.activityList?.length
        ? data.activityList.map((item) => item.activityName).join('、')
        : '--'
      this.receiveData = data.orderPlanFeeList

      const { orderConfig = {} } = data || {}
      const { piecewiseCalculation = {} } = orderConfig || {}
      const { isOpen = 0, piecewiseConfigList = [] } =
        piecewiseCalculation || {}
      this.configSource.isOpen = SelectOption.schemeTypeList[Number(isOpen)]
      // 阶梯配置详情
      this.piecewiseConfigList =
        (isOpen === 1 &&
          piecewiseConfigList.map((item) => {
            return {
              ladderDate: `${item.startMonth}至${item.endMonth}月`,
            }
          })) ||
        []
      // 司机合作模式字段
      this.configSource.payMode = payModeList[data.payPlanFee?.payMode]
      if (data.payPlanFee?.rentAmount) {
        this.configSource.driverRentAmount =
          data.payPlanFee?.rentAmountType === RENT_AMOUNT_TYPE.DAY
            ? `每日${data.payPlanFee?.rentAmount}元*当期自然天数`
            : `${data.payPlanFee?.rentAmount}元`
      }
      this.configSource.payPlanType =
        payPlanTypeList[data.payPlanFee?.payPlanType]
      const settlementAmountItem = this.configColumn.find(
        (item) => item.key === 'settlementAmount',
      )

      if (settlementAmountItem) {
        settlementAmountItem.tableList = (
          data.payPlanFee?.commissionList || []
        ).map((item, index) => {
          return {
            dynamicCondition: `${item.startValue}≤当期支付总金额<${
              item.endValue &&
              index !== data.payPlanFee.commissionList.length - 1
                ? item.endValue
                : '不限'
            }`,
            settlementAmount: getSettlementAmountFormula({
              baseSalary: item.baseSalary,
              commissionType: data.payPlanFee.commissionType,
              commissionRate: item.commissionRate,
              startValue: item.startValue,
            }),
          }
        })
      }

      // 司机合作模式-结算金额类型为固定金额时过滤动态金额
      if (data.payPlanFee?.payPlanType === PAY_PLANT_TYPE.FIXED) {
        this.configColumn = this.configColumn.filter(
          (item) => item.key !== 'settlementAmount',
        )
        if (data.payPlanFee?.planAmount) {
          this.configSource.planAmount =
            data.payPlanFee?.planAmountType === PLANT_AMOUNT_TYPE.DAY
              ? `每日${data.payPlanFee?.planAmount}元*当期自然天数`
              : `${data.payPlanFee?.planAmount}元`
        }
      } else {
        this.configColumn = this.configColumn.filter(
          (item) => item.key !== 'planAmount',
        )
      }
    },
    async fetchCarAgeOptions() {
      const { code, data } = await getEnum({ type: 'carAgeEnum' })
      if (code === 1) {
        this.carAgeOptions = data || []
      }
    },
    // 去编辑页面
    goEditPage() {
      this.$router.push({
        path: '/car_to_lease/leaseScheme/edit',
        query: {
          id: this.id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.container-box {
  ::v-deep .column-box {
    .el-form-item__content {
      .el-input,
      .el-select,
      .el-textarea,
      .el-date-editor {
        width: 300px !important;
      }
    }
  }
  .orderConfig {
    margin-bottom: 10px;
  }
}
</style>
